var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: _vm.file.categoria
          ? "Ver respuesta Expediente " +
            _vm.file.categoria +
            "-" +
            _vm.file.numero
          : "Ver respuesta Expediente " + _vm.file.numero,
        "hide-footer": "",
        centered: ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c(
        "div",
        [
          _c("h5", [_vm._v(" Respuesta ")]),
          _c(
            "vs-table",
            {
              attrs: { data: _vm.fileResponse },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var data = ref.data
                    return _vm._l(data, function(tr, indextr) {
                      return _c(
                        "vs-tr",
                        { key: indextr },
                        [
                          _c("vs-td", [
                            _vm._v(
                              " " + _vm._s(data[indextr].usuarioNombre) + " "
                            )
                          ]),
                          _c(
                            "vs-td",
                            {
                              attrs: {
                                data: _vm.fileResponse[indextr].adjuntoId
                              }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(data[indextr].adjuntoNombre) + " "
                              )
                            ]
                          ),
                          _c(
                            "vs-td",
                            [
                              _c("DownloadFile", {
                                staticClass: "pill-info-attach",
                                attrs: {
                                  mood: "compact",
                                  path: data[indextr].adjuntoUrl,
                                  name: data[indextr].adjuntoNombre
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    })
                  }
                }
              ])
            },
            [
              _c(
                "template",
                { slot: "thead" },
                [
                  _c("vs-th", [_vm._v(" Nombre usuario ")]),
                  _c("vs-th", [_vm._v(" Archivo ")]),
                  _c("vs-th", [_vm._v(" Ver ")])
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }